import React from "react";
import { twMerge } from "tailwind-merge";
import { Skeleton } from "@components/Skeleton/Skeleton";

export const MessagesListSkeleton: React.FC = () => {
  return Array(3)
    .fill(0)
    .map((_, index) => (
      <div
        key={index}
        className={twMerge(
          "relative grid gap-2 border-b border-grey-light px-4 py-4 last:border-none",
          index === 0 && "bg-base-light-grey",
        )}
      >
        <Skeleton className="text-md" />
        <Skeleton className="w-20 text-xs" />
      </div>
    ));
};
